import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useEffect, useState } from "react";
import {
  createPurchaseInvoice,
  getPurchaseInvoiceList,
  getPurchaseInvoicePrint,
  payInvoice,
  updatePurchaseInvoice,
} from "../../../../services/workspace/inventory.service";
import DefaultInvoice from "../../common/invoice/defaultInvoice";
import InvoiceTable from "../../common/invoice/components/table";
import InvoiceBasicDetails from "./components/invoiceBasicDetails";
import SubTotal from "../../common/invoice/components/subTotal";
import DefaultButton from "../../../components/buttons/defaultButton";
import BottomDrawer from "../../common/drawer/bottomDrawer";
import { ImPrinter } from "react-icons/im";
import { downloadFile } from "../../../../utils/helper";
import toast from "react-hot-toast";
import CommonModal from "../../../components/modals/commonModel";
import DefaultInput from "../../../components/inputs/defaultInput";
import CommonForm from "../../../components/form/form";
import { CgLayoutGrid } from "react-icons/cg";

const actions_type = {
  DELETE: "DELETE",
  EDIT: "EDIT",
  VIEW: "VIEW",
  ASSIGN: "ASSIGN",
  CLEAR: "CLEAR",
  EXPIRE: "EXPIRE",
};

const items = [{ label: "Purchase Invoice", path: "" }];

const PurchaseInvoice = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [isSubCategoryModalOpen, setIsSubCategoryModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [isOpenSheet, setIsOpenSheet] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const customCase = {
    Pending: {
      label: "Pending",
      color: "text-yellow-500 text-sm",
      bg: "bg-yellow-500",
    },
    "Partially Paid": {
      label: "Partially Paid",
      color: "text-orange-400 text-sm",
      bg: "bg-orange-400",
    },
    Paid: {
      label: "Paid",
      color: "text-green-600 text-sm",
      bg: "bg-green-600",
    },
    Unpaid: {
      label: "Unpaid",
      color: "text-red-600 text-sm",
      bg: "bg-red-600",
    },
  };

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    // selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    softDelete,
    // New sorting helpers
    sortingUIProps,
  } = useCommonFetch(getPurchaseInvoiceList, {
    dataPath: "purchaseInvoice.data",
    totalPath: "purchaseInvoice.meta.total",
    errorMessage: "Failed to fetch purchase order data!",
    debounceDelay: 500,
    customParams: {
      with: "purchaseOrder,createdBy",
    },
    // Dynamic sorting configuration
    sortingOptions: [
      { label: "Name", field: "title" },
      { label: "Date", field: "created_at" },
    ],
    sortingModule: "purchaseInvoice",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,
    // Add data transformer function
    dataTransformer: (data) => {
      if (Array.isArray(data)) {
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item?.id,
            className: "",
            sticky: false,
            variant: "text",
          },
          uuid: {
            data: item?.uuid,
            className: "",
            sticky: false,
            variant: "text",
          },
          name: {
            data: item?.title,
            className: "",
            sticky: false,
            variant: "name",
          },
          code: {
            data: item?.code,
            className: "",
            sticky: false,
            variant: "name",
          },
          due_date: {
            data: item?.due_date,
            className: "",
            sticky: false,
            variant: "date",
          },
          vendor: {
            data: item?.purchaseOrder?.vendor?.name,
            className: "",
            sticky: false,
            variant: "text",
          },
          vendorAddress: {
            data: item?.purchaseOrder?.vendor?.address,
            className: "",
            sticky: false,
            variant: "text",
          },
          created_at: {
            data: item?.created_at,
            className: "",
            sticky: false,
            variant: "date",
          },
          total_amount: {
            data: item?.purchaseOrder?.total_amount,
            className: "",
            sticky: false,
            variant: "text",
          },
          payment_status: {
            data: item?.purchaseOrder?.payment_status,
            className: "",
            sticky: false,
            variant: "status",
            customCases: customCase,
          },
          balance_amount:{
            data: item?.purchaseOrder?.balance_amount,
            className: "",
            sticky: false,
            variant: "text",
          },
          stockItems: {
            data: item?.purchaseOrder?.stockItems ?? [],
            className: "",
            sticky: false,
            variant: "status",
            customCases: null,
          },
          actions: {
            data: item?.id,
            className: "",
            sticky: false,
            variant: "text",
          },
        }));

        const actionButton = {
          view: (item) => {
            // unwrap raw data for drawer
            const rawItem = {
              uuid: item?.uuid.data,
              name: item?.name.data,
              code: item?.code.data,
              due_date: item?.due_date.data,
              vendor: item?.vendor.data,
              vendorAddress: item?.vendorAddress.data,
              created_at: item?.created_at.data,
              total_amount: item?.total_amount.data,
              payment_status: item?.payment_status.data,
              stockItems: item.stockItems.data,
              balance_amount: item.balance_amount.data,
              ...item,
            };

            setSelectedId(rawItem);
            setIsOpenSheet(true);

            setIsEditValue({
              id: rawItem?.uuid,
              name: rawItem?.name,
              description: rawItem?.description,
            });
          },
        };

        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  const TableHeaderData = [
    {
      label: "Invoice No.",
      key: "code",
    },
    {
      label: "Invoice Title",
      key: "name",
    },
    {
      label: "Purchase Order No.",
      key: "code",
    },
    {
      label: "Vendor Name",
      key: "vendor",
    },
    {
      label: "Invoice Date",
      key: "created_at",
    },
    {
      label: "Due Date",
      key: "due_date",
    },
    {
      label: "Amount",
      key: "total_amount",
    },
    {
      label: "Status",
      key: "payment_status",
    },
  ];

  const toggleModal = () => {
    if (!selectedId) {
      toast.error("Please select at least one item for payment.");
      return;
    }

    setIsModalOpen(!isModalOpen);
  };

  const printPurchaseInvoice = async (invoice) => {
    setPrintLoading(true);
    try {
      const response = await getPurchaseInvoicePrint(
        invoice?.purchaseOrder?.uuid
      );
      if (response) {
        downloadFile(response, "Purchase Invoice");
      }
    } catch (error) {
      console.error("Error fetching Invoice data:", error);
    } finally {
      setPrintLoading(false);
    }
  };

  const FormFields = [
    {
      name: "receipt_id",
      type: "text",
      label: "Transaction ID / Receipt ID",
      placeholder: "Enter Transaction ID / Receipt ID",
      required: true,
      minLength: 2,
      maxLength: 50,
    },
    {
      name: "amount",
      type: "number",
      label: "Amount",
      placeholder: "Enter Amount",
      required: true,
    },
    {
      name: "file",
      type: "file",
      label: "Upload Document",
      placeholder: "Upload Document",
    },
  ];

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        receipt_number: values.receipt_id || null,
        amount: parseFloat(values.amount) || 0,
        payment_mode: 0,
        payment_date: new Date().toISOString().split("T")[0],
        purchase_order_id: selectedId?.purchaseOrder?.id,
      };

      await payInvoice(payload);
      toast.success("Payment recorded successfully!");

      resetForm();
      setIsModalOpen(false);
      navigator("inventory/purchase-invoice");
    } catch (error) {
      console.error("Error submitting payment:", error);
      toast.error("Failed to submit payment!");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    // Handle cancellation logic
  };

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        shorting
        sortingModule="purchaseInvoice"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
      />

      <div className={"flex flex-col gap-2"}>
        <CommonTable
          search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
        />

        <BottomDrawer
          isOpen={isOpenSheet}
          setIsOpen={setIsOpenSheet}
          title="Purchase Invoice"
          size={"md"}
        >
          <div className="flex flex-row items-center justify-between h-14">
            <span className="flex flex-row gap-2 items-center">
              <p className="font-bold text-primary-950">
                {selectedId?.code?.data}
              </p>
              {/* <DefaultBadge /> */}
              <div
                className={`border rounded-md py-1 px-2 max-w-max items-center ${
                  selectedId?.purchaseOrder?.payment_status === "Paid"
                    ? "bg-green-50 text-green-700"
                    : "bg-red-50 text-red-700"
                }`}
              >
                {selectedId?.purchaseOrder?.payment_status || "-"}
              </div>
            </span>
            <span className="flex flex-row gap-2 items-center">
              <DefaultButton
                name={"Print"}
                variant={"secondary"}
                icon={<ImPrinter />}
                loading={printLoading}
                onClick={() => {
                  printPurchaseInvoice(selectedId);
                }}
              />
            </span>
          </div>
          <DefaultInvoice>
            <div className="border-b py-2 flex flex-col gap-4">
              <InvoiceBasicDetails item={selectedId} />
              <InvoiceTable
                // data={selectedId?.purchaseOrder?.stock_items ?? []}
                tableData={
                  selectedId &&
                  selectedId?.purchaseOrder &&
                  selectedId?.purchaseOrder?.stockItems
                    ? selectedId?.purchaseOrder?.stockItems
                    : []
                }
              />
              <SubTotal data={selectedId?.purchaseOrder} isInventory={true} />
              {selectedId?.purchaseOrder?.payment_status !== "Paid" && (
                <div className="flex items-center gap-2 text-primary-950 font-bold">
                  Please Pay Balance Amount-
                  <DefaultButton name="Cash" onClick={toggleModal} />
                </div>
              )}
            </div>
          </DefaultInvoice>
        </BottomDrawer>
        {isModalOpen && (

          <CommonModal
            modalSize="lg"
            headerTitle={"Cash Detail"}
            onClose={() => {
              setIsModalOpen(false);
            }}
            show={isModalOpen}
          >
            <CommonForm
              fields={FormFields}
               initialData={{
                receipt_id: "",
                amount: selectedId?.balance_amount?.data || 0,
                file: null,
              }}
              enableReinitialize={true}
              onSubmit={handleSubmit}
              submitButtonText="Submit"
              onCancel={() => setIsModalOpen(false)}
              className=""
            />
          </CommonModal>
        )}
      </div>
    </div>
  );
};
export default PurchaseInvoice;
